import { z } from 'zod';

/**
 * `string | null` -> `number` by `parseFloat`
 * @default 0
 */
export const NullableStringToParsedFloatSchema = z
  .string()
  .nullable()
  .transform((val) => {
    const parsed = parseFloat(val || '');
    return isNaN(parsed) ? 0 : parsed;
  });

export const makeNullableNumberSchema = (default_value: number) => {
  return z
    .number()
    .nullable()
    .transform((val) => (val === null ? default_value : val));
};

/**
 * `number | null` -> `number`
 * @default 0
 */
export const NullableNumberSchema = makeNullableNumberSchema(0);

export const PriceSchema = z.object({
  price: NullableNumberSchema,
  price_en: NullableStringToParsedFloatSchema,
  price_jp: NullableNumberSchema,
});
